import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import type { DSAttendanceConciliateCandidate } from '@/Network/Types/Responses/DsAttendancePolicyResponses'

const NOT_INFORMED = 'Não informado'

/** Mesmo shape de `BestCandidateDateInfo` (CardBestCandidate.vue), declarado aqui para o `tsc`. */
export interface CandidateDateInfo {
  weekday: string
  date: string
  time: string
}

export interface ConciliationCandidateCardProps {
  stationId: number | string
  stationType: string
  title: string
  breadcrumb: string
  allocatedBy: string
  startDate: CandidateDateInfo | undefined
  endDate: CandidateDateInfo | undefined
  timezone: string
  doctor: {
    name: string
    crm: string
    formation: string
    team: string
    position: string
    shift: string
    dutyLabel: string
  }
}

export function formatCandidateDate(isoString: string): CandidateDateInfo {
  const date = new Date(isoString)
  return {
    weekday: format(date, 'EEEE', { locale: ptBR }),
    date: format(date, 'dd/MM/yyyy'),
    time: format(date, 'HH:mm')
  }
}

const buildCandidateBreadcrumb = (candidate: DSAttendanceConciliateCandidate): string =>
  [
    candidate.company?.name,
    candidate.healthUnit?.name,
    candidate.sector?.name,
    candidate.position?.name
  ]
    .filter(Boolean)
    .join(' > ')

const mapCandidateDoctor = (
  candidate: DSAttendanceConciliateCandidate
): ConciliationCandidateCardProps['doctor'] => {
  const doctor = candidate.doctor ?? null
  return {
    name: doctor?.name ?? NOT_INFORMED,
    crm: doctor?.crm ? `${doctor.crm.number}/${doctor.crm.uf}` : NOT_INFORMED,
    formation: doctor?.formation?.name ?? NOT_INFORMED,
    team: candidate.team ?? NOT_INFORMED,
    position: candidate.position?.name ?? NOT_INFORMED,
    shift: candidate.shift?.name ?? NOT_INFORMED,
    dutyLabel: ''
  }
}

/** W-30 — candidato sem médico não pode derrubar o modal de conciliação. */
export function mapCandidateToCardProps(
  candidate: DSAttendanceConciliateCandidate
): ConciliationCandidateCardProps {
  return {
    stationId: candidate.stationId,
    stationType: candidate.stationType,
    title: 'Detalhes do Plantão',
    breadcrumb: buildCandidateBreadcrumb(candidate),
    allocatedBy: candidate.allocatedBy?.name ?? NOT_INFORMED,
    startDate: candidate.startDate ? formatCandidateDate(candidate.startDate) : undefined,
    endDate: candidate.endDate ? formatCandidateDate(candidate.endDate) : undefined,
    timezone: 'Brasília',
    doctor: mapCandidateDoctor(candidate)
  }
}
